module.exports = __webpack_public_path__ + "img/botabib3.00ad10be.png";